<template>
  <modal background>
    <validation-observer v-slot="{ handleSubmit }" slim>
      <form @submit.prevent="handleSubmit(submit)">
        <div class="modal-card is-unselectable">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ date }}: {{ block.name }}</p>
            <button
              class="delete"
              type="button"
              aria-label="close"
              @click="cancel"
            ></button>
          </header>

          <section class="modal-card-body content">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <label class="label">Czas rozpoczęcia</label>
                  <control-date-time-picker
                    ref="beginTime"
                    name="czas rozpoczęcia"
                    v-model="beginTime"
                    date-format="H:i"
                    alt-format="H:i"
                    icon-left="fa-clock"
                    vid="begin-time"
                    rules="required"
                    placeholder="Godzina rozpoczęcia..."
                    time
                    no-calendar
                  />
                </div>
                <div class="field">
                  <label class="label">Czas zakończenia</label>
                  <control-date-time-picker
                    ref="endTime"
                    v-model="endTime"
                    date-format="H:i"
                    alt-format="H:i"
                    icon-left="fa-clock"
                    rules="required|is_after:time,@begin-time"
                    placeholder="Godzina zakończenia..."
                    time
                    no-calendar
                  />
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Tytuł programu</label>
              <control-input
                type="text"
                v-model.trim="title"
                rules="required"
                placeholder="Wprowadź tytuł programu..."
                icon-left="fa-tag"
              />
            </div>
          </section>

          <footer class="modal-card-foot">
            <button
              class="button is-success"
              :class="{ 'is-loading': submitting }"
              :disabled="submitting"
              type="submit"
            >
              <icon :name="item ? 'fa-save' : 'fa-plus'" />
              <span>{{ item ? "Zapisz" : "Dodaj" }}</span>
            </button>
            <button class="button" type="button" @click="cancel">Anuluj</button>
          </footer>
        </div>
      </form>
    </validation-observer>
  </modal>
</template>

<script>
import { Modal } from "%modals";

import ControlDateTimePicker from "%admin/components/global/ControlDateTimePicker";

import { Icon, ControlInput } from "%helpers";

export default {
  name: "program-item-modal",

  components: {
    Modal,
    Icon,
    ControlDateTimePicker,
    ControlInput
  },

  props: {
    date: String,
    block: Object,
    item: Object,
    onSubmit: Function
  },

  data() {
    return {
      beginTime: "",
      endTime: "",
      title: "",
      submitting: false
    };
  },

  mounted() {
    if (this.item) {
      this.beginTime = this.item.beginTime.substr(0, 5);
      this.endTime = this.item.endTime.substr(0, 5);
      this.title = this.item.title;
    }
  },

  methods: {
    submit() {
      if (!this.submitting) {
        this.submitting = true;

        this.onSubmit(
          {
            date: this.date,
            programBlock: this.block,
            beginTime: this.beginTime,
            endTime: this.endTime,
            title: this.title
          },
          this.item && this.item.id
        )
          .then(() => this.cancel())
          .catch(({ response }) => this.handleBackendValidationError(response))
          .finally(() => (this.submitting = false));
      }
    },

    handleBackendValidationError(response) {
      if (response.data.code === "VALIDATION_ERROR") {
        this.$refs.beginTime.setErrors([
          "Podany czas koliduje z innym punktem"
        ]);
        this.$refs.endTime.setErrors(["Podany czas koliduje z innym punktem"]);
      }
    },

    cancel() {
      this.$emit("hide");
    }
  }
};
</script>

<style></style>
